<template lang="pug">
  .lg_container
    <global-header></global-header>
    .banner_container
      img(v-if="!websiteInfo.studentBannerFlag && websiteInfo.studentBannerUrlList && websiteInfo.studentBannerUrlList.length > 0" :src="websiteInfo.studentBannerUrlList[0]")
      img(v-else src="@/assets/banner/student_banner.jpg")
    //- 学员风采
    .student_box(v-if="websiteInfo.studentVideoUrlList.length > 0")
      img.title(src="@/assets/student/mien.png")
      .video_box(@click="onOpenVideo(websiteInfo.studentVideoUrlList[0])")
        video.studentMien_img(:poster="websiteInfo.studentVideoUrlList[0] + '?vframe/jpg/offset/0'" :src="websiteInfo.studentVideoUrlList[0]")
        img.video_btn(src="@/assets/student/video_icon.png")
      .studentMien_list(v-if="websiteInfo.studentVideoUrlList && websiteInfo.studentVideoUrlList.length > 1")
        .studentMien_item(v-for="(item, index) in websiteInfo.studentVideoUrlList.slice(1)" :key="index" @click="onOpenVideo(item)")
          video.studentMien_img(:poster="item + '?vframe/jpg/offset/0'" :src="item")
          img.video_btn(src="@/assets/student/video_icon.png")
    //- 什么是AI双师课堂
    .student_box
      img.title(src="@/assets/student/two_teacher.png")
      .content AI双师课堂，由外教老师线上授课，中教老师线下实时辅导，两位老师分工协作，保证学习效果。依托国际先进的TPR、CLT、CLIL、PBL教学方法，把英语中核心素养的部分，通过人的因素和技术的手段引入到课堂中来，为孩子提供一个多模态，真语境的学习环境。借助情景化的AI课件内容有效提升孩子学习兴趣，轻松自然的理解课堂内容，开启孩子爱上英语的大门。
      img.feature_img(src="@/assets/student/feature.png")
      .feature_list
        .feature_item
          img.left.t1(src="@/assets/student/t1.png")
          .content_right
            h3 一大教学特色
            p 动画片教学
        .feature_item
          img.left.t2(src="@/assets/student/t2.png")
          .content_right
            h3 两大全球首创
            p AI双师情景互动课件+提问式VIC教学法
        .feature_item
          img.left.t3(src="@/assets/student/t3.png")
          .content_right
            h3 三大产品核心
            p 双师教学模式+完善的学习闭环+自主研发的课程
      .content_bg
        p · 双师教学模式：外教老师为孩子提供母语教学环境，中教老师引导输出因材施教。我们的师资团队：哈佛外教、好莱坞演员、中英文双语主持
        p · 完善的学习闭环：课前儿歌预习+课中故事情景互动+课后课堂音频输入+测评闯关检测
        p · 自主研发的课程：基于“二语习得”原理和“母语式教学法”自主独立研发，耗时1万小时的匠心打造，培养孩子的语言思维，成为未来社会多元国际公民。
    //- 五大优势
    .student_box
      img.title.height20(src="@/assets/student/advantage.png")
      van-swipe(:show-indicators="false" :loop="false" :width="width")
        van-swipe-item(v-for="(item, index) in advantageData" :key="index")
          .advantage_box
            img(:src="item.img")
            .advantage_con
              h3 {{item.title}}
              p {{item.content}}
    //- 传统课堂VS双师课堂
    .student_box
      img.title.height24(src="@/assets/student/classroom.png")
      .classroom_box
        .tradition
          h3 1、输入量少
          p 小学阶段课标要求词汇量700-900
          h3 2、日常生活主题为主
          p 先学后用，不能“即学即用”
          h3 3、教材陈旧，多年不变
          p 语言是需要不断更新迭代的
          h3 4、没有自然的语境
          p 一个班几十个孩子，不能全英文授课
        .two_techaer
          h3 1、即学即用
          p 学习的内容更丰富，用语言来学习知识
          h3 2、对接国际标准
          p 参考欧标等国际标准，为孩子的未来夯定基础
          h3 3、能力+素质双向培养
          p 听说读写全面发展，注重语用能力的培养
          h3 4、外教+中教
          p 双师教学，创造母语习得环境更容易
    //- 视频
    popup.videoPopup(v-model="isVideoShow" @close="onBrowserBack")
      videoMien(:videoUrl="videoUrl" style='width: 100%;')
    <global-footer></global-footer>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
import { Popup } from 'vant'
import videoMien from '@/components/video/index'
export default {
  name: 'StudentMien',
  components: {
    Popup,
    videoMien,
    GlobalHeader,
    GlobalFooter
  },
  computed: {
    ...mapGetters(['websiteInfo'])
  },
  data() {
    return {
      // 学员风采
      studentData: [],
      // 五大优势
      advantageData: [
        {
          img: require('@/assets/student/classroom_img01.png'),
          title: '一、100次开口互动',
          content: '每个孩子配备一个语音答题器，可在课堂中通过语音形式比拼答题，通过外教引导和丰富多样的互动题型设置，引导学生开口互动，语音测评系统实时打分，并记录答题数据，并记录答题数据。'
        },
        {
          img: require('@/assets/student/classroom_img02.png'),
          title: '二、互动情景式教学',
          content: '利用虚拟演播室技术，将计算机制作的三维情景化课件，与摄像机现场拍摄的外教授课画面进行数字化实时合成，实现课件和外教的同步变化，为孩子创造自然有趣真实的交际环境。'
        },
        {
          img: require('@/assets/student/classroom_img03.png'),
          title: '三、先进的教学理念',
          content: '依托国际先进的TPR、CLT、CLIL、PBL教学方法，参考国内外顶级、权威、专业的大出版社的教材，对标2018中国英语能力等级量表（CSE）和欧洲语言共同参考框架（CEFR），课程主题全面覆盖新课标的24个大话题。'
        },
        {
          img: require('@/assets/student/classroom_img04.png'),
          title: '四、实时语音测评',
          content: '用科技传递优质教育，全数据追踪，实时记录孩子发音情况。'
        },
        {
          img: require('@/assets/student/classroom_img05.png'),
          title: '五、完整的学习闭环',
          content: '课前儿歌预习，课中故事情景互动，课后课堂音频输入，测评闯关检测。'
        }
      ],
      // 视频是否播放
      isVideoShow: false,
      // 视频地址
      videoUrl: '',
      width: (document.documentElement.clientWidth || document.body.clientWidth) / 375 * 320
    }
  },
  watch: {
    isVideoShow: {
      handler(newVal, oldVal) {
        if (newVal) {
          window.history.pushState(null, null, document.URL)
        }
      },
      deep: true
    }
  },
  mounted() {
    window.addEventListener('popstate', this.onBrowserBack, false)
  },
  methods: {
    // 打开视频
    onOpenVideo(url) {
      if (url) {
        this.videoUrl = url
        this.isVideoShow = true
      }
    },
    // 返回关闭
    onBrowserBack() {
      this.isVideoShow = false
      this.videoUrl = ''
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.onBrowserBack, false)
  }
}
</script>

<style lang="scss" scoped>
.lg_container {
  .student_box {
    padding: 0 20px;
    text-align: center;
    margin-bottom: 10px;
    position: relative;
    .title {
      height: 21px;
      margin: 30px 0;
      &.height20 {
        height: 20px;
      }
      &.height24 {
        height: 24px;
      }
    }
    .video_box {
      width: 100%;
      height: 200px;
      border-radius: 8px;
      overflow: hidden;
      position: relative;
      .studentMien_img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .video_btn {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 50px;
      }
    }
    .studentMien_list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      .studentMien_item {
        position: relative;
        margin-right: 10px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .studentMien_img {
          width: 105px;
          height: 67px;
          border-radius: 8px;
          overflow: hidden;
          object-fit: cover;
        }
        .video_btn {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 30px;
        }
      }
    }
    .content {
      text-align: left;
      color: #33373f;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 30px;
    }
    .feature_img {
      width: 100vw;
      margin: 20px 0 30px -20px;
    }
    .feature_list {
      .feature_item {
        display: flex;
        align-items: center;
        padding: 20px;
        margin-bottom: 16px;
        background-color: #f8fbfc;
        .left {
          &.t1 {
            width: 43px;
            height: 39px;
          }
          &.t2 {
            width: 57px;
            height: 30px;
          }
          &.t3 {
            width: 49px;
            height: 46px;
          }
          margin-right: 30px;
        }
        .content_right {
          flex: 1;
          text-align: left;
          h3 {
            color: #33373f;
            font-size: 16px;
            font-weight: bold;
          }
          p {
            color: #33373f;
            font-size: 14px;
            margin-top: 8px;
          }
        }
      }
    }
    .content_bg {
      padding: 20px;
      background-color: #f8fbfc;
      border-radius: 8px;
      color: #33373f;
      font-size: 14px;
      line-height: 24px;
      text-align: left;
      p {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .classroom_box {
      border-radius: 8px;
      border: 4px solid #e7f9ff;
      text-align: left;
      padding-bottom: 40px;
      // 传统课堂
      .tradition {
        padding-top: 84px;
        position: relative;
        padding-left: 37px;
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          top: 20px;
          left: -4px;
          width: 285px;
          height: 40px;
          background: url('~@/assets/student/class1.png') no-repeat;
          background-size: 285px 40px;
        }
      }
      // 双师课堂
      .two_techaer {
        padding-top: 84px;
        padding-left: 37px;
        position: relative;
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          top: 20px;
          left: -4px;
          width: 285px;
          height: 40px;
          background: url('~@/assets/student/class2.png') no-repeat;
          background-size: 285px 40px;
        }
      }
      h3 {
        color: #33373f;
        font-size: 16px;
        font-weight: bold;
      }
      p {
        color: #666a72;
        font-size: 14px;
        margin-bottom: 18px;
      }
    }
  }
}
::v-deep .van-swipe {
  border-radius: 8px;
  padding-bottom: 10px;
  padding-left: 4px;
  overflow: hidden;
  .van-swipe-item {
    padding-right: 20px;
    .advantage_box {
      width: 100%;
      height: 340px;
      background: #ffffff;
      box-shadow: 0px 4px 8px 0px rgba(26, 153, 135, 0.15);
      border-radius: 8px;
      img {
        width: 100%;
        height: 166px;
      }
      .advantage_con {
        padding: 15px 20px 0 15px;
        text-align: left;
        h3 {
          color: #33373f;
          font-size: 16px;
        }
        p {
          color: #666a72;
          font-size: 13px;
          margin-top: 8px;
          line-height: 18px;
        }
      }
    }
  }
}
.videoPopup {
  width: 340px;
}

</style>
